export default __webpack_public_path__ + "static/media/4belt-icon.66aba232.png";